<template>
    <VModal name="report-message" :width="400" height="auto" close-button @closed="clearForm">
        <div class="report-modal">
            <h2 class="report-modal__title">Report Message</h2>

            <div class="report-modal__form">
                <label for="report-reason" class="report-modal__label">Reason for reporting:</label>
                <VTextarea id="report-reason" v-model="reason" class="report-modal__textarea"
                    placeholder="Please describe why you're reporting this message..." :rows="4" />

                <div class="report-modal__notice">
                    Your report will be reviewed by staff. Posting false reports may result in your account being
                    disabled.
                </div>
            </div>

            <div class="report-modal__footer">
                <Button @click="cancel" type="secondary">Cancel</Button>
                <Button @click="submitReport" :disabled="!reason.trim()" type="primary">Submit Report</Button>
            </div>
        </div>
    </VModal>
</template>

<script>
import VModal from '@/components/VModal.vue';
import Button from '@/components/Button.vue';
import VTextarea from '@/components/VTextarea.vue';

export default {
  name: 'ReportModal',
  components: {
    VModal,
    Button,
    VTextarea,
  },
  data() {
    return {
      reason: '',
      messageData: null,
    };
  },
  methods: {
    clearForm() {
      this.reason = '';
      this.messageData = null;
    },

    cancel() {
      this.$modal.hide('report-message');
    },

    submitReport() {
      if (!this.reason.trim()) return;

      this.$emit('submit-report', {
        reason: this.reason,
        messageData: this.messageData,
      });

      this.$modal.hide('report-message');
    },

    // Method to be called when opening the modal
    setMessageData(data) {
      this.messageData = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.report-modal {
    &__title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 15px;
        color: var(--text-primary);
    }

    &__form {
        margin-bottom: 20px;
    }

    &__label {
        display: block;
        margin-bottom: 5px;
        font-size: 14px;
        color: var(--text-primary);
    }

    &__textarea {
        width: 100%;
        margin-bottom: 10px;
    }

    &__notice {
        font-size: 12px;
        color: var(--text-secondary);
        line-height: 1.4;
    }

    &__footer {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }
}
</style>
